import { IEvent, IEventStatus } from "core-integration/src/store/events/types";
import { addDays, format, parseISO } from "date-fns";
import { fromZonedTime } from "date-fns-tz";

// Checks the following to determine if it is a first save of the Gameweek:
// 1. During preseason, if picks haven't been updated since entry creation (with 5 seconds of leeway)
// 2. During the season, if the picks were last updated before the most recent deadline
export const isFirstSave = (
  picksLastUpdated: string | null,
  currentEvent: IEvent | null,
  joinedTime: string,
): boolean => {
  if (!picksLastUpdated) return false;

  const picksUpdated = new Date(picksLastUpdated).getTime();

  return currentEvent
    ? // During season
      picksUpdated <= new Date(currentEvent.deadline_time).getTime()
    : // Preseason
      picksUpdated - new Date(joinedTime).getTime() <= 5_000;
};

// Gameweek is finalised at 9am UK time the day after the last match day
export const getGameweekFinalTime = (status: IEventStatus[]) => {
  const lastMatchDay = status
    .map((s) => s.date)
    .sort()
    .at(-1);
  if (!lastMatchDay) {
    return undefined;
  }
  const finalDay = format(addDays(parseISO(lastMatchDay), 1), "yyyy-MM-dd");
  return fromZonedTime(`${finalDay}T09:00:00`, "Europe/London");
};
